<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              :footer-props="datatable_footer"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onFilterDialog"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <timezone-picker
                          v-model="timeZone"
                        />
                      </v-col>

                      <v-col
                        cols="12"
                        md="2"
                        offset-md="2"

                        class="d-flex justify-md-end"
                      >
                        <v-btn
                          color="secondary"
                          outlined
                          @click="onReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                        <v-icon
                          medium
                          class="icon-table"
                          @click="onShowHeaderDialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <div v-if="filter.set">
                          <v-chip
                            v-for="(filter, index2) in filter_fields.common.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min)"
                            :key="'data_f' + index2"
                            color="grey lighten-2"
                            class="ma-1"
                            close
                            @click:close="onClearFilterValue(filter)"
                          >
                            <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                            <span v-else-if="filter.type == 'number'">{{ filter.name }}: {{ (filter.min) }}/{{ (filter.max) }}</span>
                            <span v-else-if="filter.type == 'select' || filter.type == 'autocomplete'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                            <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.createdTZ="{ item }">
                <span v-if="item && item.createdTZ">
                  {{ format_date(item.createdTZ) }}
                </span>
              </template>
              <template v-slot:item.view_only="{item}">
                <v-menu
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      v-bind="attrs"
                      color="primary"
                      v-on="on"
                      @click="onViewConfiguration(item)"
                    >
                      <v-icon>
                        mdi-open-in-new
                      </v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="filter_dialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="headline">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-card flat>
              <v-card-text>
                <div
                  v-for="(field, index2) in filter_fields.common.data"
                  :key="'i_'+index2"
                >
                  <v-select
                    v-if="field.type=='select'"
                    v-model="field.value"
                    clearable
                    :label="field.name"
                    :items="field.select"
                    @change="filter.changed = true"
                  />
                  <div
                    v-else-if="field.type=='date'"
                    clearable
                    :label="field.name"
                    :items="field.select"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="field.date_select"
                          clearable
                          :label="field.name"
                          :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                          @change="onChangeFilterDateType($event, field)"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="field.from"
                          :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                          :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                          type="date"
                          :max="max_date"
                          @input="filter.changed = true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-if="field.date_select == 'period'"
                          v-model="field.to"
                          label="До"
                          type="date"
                          :max="max_date"
                          @input="filter.changed = true"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else-if="field.type=='number'">
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          :label="field.name"
                          readonly
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="field.min"
                          label="От"
                          type="number"
                          @input="filter.changed = true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="field.max"
                          label="До"
                          type="number"
                          @input="filter.changed = true"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <v-autocomplete
                    v-else-if="field.type==='autocomplete'"
                    v-model="field.value"
                    clearable
                    :label="field.name"
                    :items="field.select"
                    @change="filter.changed = true"
                  />
                  <v-text-field
                    v-else
                    v-model="field.value"
                    :label="field.name"
                    :type="field.type"
                    @input="filter.changed = true"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="filter_dialog = false, onSetFilter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="filter_dialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="headline">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, onSetHeaders()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import { JustpayFinalreconService } from "@/views/loyalty/shared/services/justpay-finalrecon-service"
import TimezonePicker from "@/views/loyalty/shared/components/timezone-picker/TimezonePicker.vue"
import { utcToZonedTime } from "date-fns-tz"
import moment from "moment"
import { JustpayPointService } from "@/views/loyalty/shared/services/justpay-point-service"
import $ from "jquery"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"

export default {
  name: 'FinalReconciliation',
  components: { TimezonePicker },
  data: () => ({
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialog: {
      headers: {
        show: false
      }
    },
    entity: 'finalRecon',
    filter_dialog: false,
    filter_fields: {
      common: {
        index: 0,
        name: "Основное",
        active: true,
        data: [
          {
            name: 'Дата/время платежа',
            data: 'created',
            type: 'date'
          },
          {
            name: 'Номер документа',
            data: 'number',
            type: 'text'
          },
          {
            name: 'Точка обслуживания',
            data: 'point_id',
            type: 'autocomplete',
            select: []
          },
          {
            name: 'Клиент',
            data: 'client',
            type: 'autocomplete',
            select: []
          },
        ]
      }
    },
    filter: {
      set: false
    },
    form: {},
    items: [],
    justpayClient: null,
    justpayFinalreconService: null,
    justpayPointService: null,
    headers: [
      {
        text: 'Просмотр',
        value: 'view_only',
        sortable: false,
        show: true
      },
        {
 text: 'Создано',
          value: 'createdTZ',
          active: true,
          active_temp: false
},
      {
 text: 'Номер',
value: 'number',
        active: true,
        active_temp: false
},
      {
 text: 'Клиент',
value: 'client',
        active: true,
        active_temp: false
},
      {
 text: 'Наименование точки',
value: 'pointName',
        active: true,
        active_temp: false
},
      {
 text: 'Номер точки',
value: 'pointNumber',
        active: true,
        active_temp: false
},
      {
 text: 'Местоположение',
value: 'placeName',
        active: true,
        active_temp: false
},
      {
 text: 'Слип',
value: 'slip',
        active: false,
        active_temp: false
},
    ],
    loading: false,
    search: '',
    table_options: {},
    timeZone: '',
    total: 0,
  }),
  computed: {
    max_date: function () {
      return moment().format('YYYY-MM-DD')
    },
  },
  watch: {
    table_options: {
      handler () {
        console.log(this.table_options)
        this.$router.push({
          query: {
            page: this.table_options.page,
            limit: this.table_options.itemsPerPage
          }
        })
        this.load()
      },
      deep: true,
    },
    timeZone: {
      handler () {
        this.items = this.getItemsWithTZ(this.items)
      }
    }
  },
  beforeMount () {
    this.justpayClient = new JustpayClient()
    this.justpayFinalreconService = new JustpayFinalreconService()
    this.justpayPointService = new JustpayPointService()
  },
  async mounted () {
    // const item = await this.justpayFinalreconService.getAll()
    // console.log('item', item.value)
    // this.items = item.value.data
    // this.total = item.value.count
    // await this.load()
    const filter = localStorage.getItem(this.entity)
    if (filter) {
      this.filter_fields = JSON.parse(filter)
      this.filter.set = true
      this.filter.changed = false
    }
    this.setDefaultHeaders()
  },
  methods: {
    format: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    format_date: function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    formatInputDate: function (_date) {
      const date = new Date(_date)
      let dd = date.getDate()
      if (dd < 10) dd = '0' + dd

      let mm = date.getMonth() + 1
      if (mm < 10) mm = '0' + mm

      let yyyy = date.getFullYear()
      if (yyyy < 10) yyyy = '0' + yyyy

      return yyyy + '-' + mm + '-' + dd
    },
    getItemsWithTZ (items) {
      items = items.map(item => {
        item.createdTZ = utcToZonedTime(item.created, this.timeZone)
        // item.updatedTZ = utcToZonedTime(item.updated, this.timeZone)
        return item
      })
      return items
    },
    async load () {
      console.log('load')
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        delete request.data.set
        delete request.data.changed
        delete request.id
      }
      const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
      request.page = page
      request.limit = itemsPerPage
      const item = await this.justpayFinalreconService.getList(request)
      console.log('item', item.value)
      this.items = item.value.data
      this.items = this.getItemsWithTZ(this.items)
      this.total = item.value.count
    },
    onChangeFilterDateType (value, field) {
      this.filter.changed = true
      console.log('changeFilterDateType', value, field)
      if (field && value) {
        if (value !== 'period' && value !== 'date') {
          let date = 0
          if (value == 'today') {
            date = new Date()
          } else if (value == 'yesterday') {
            date = new Date().setDate(new Date().getDate() - 1)
          } else if (value == 'tomorrow') {
            date = new Date().setDate(new Date().getDate() + 1)
          }
          const formated_date = this.formatInputDate(date)
          field.from = formated_date
          field.to = formated_date
        }
        if (value == 'date') {
          field.to = ''
        }
      }
    },
    onClearFilterValue (field) {
      console.log('onClearFilterValue')
      field.value = ''
      field.from = ''
      field.to = ''
      field.date_select = ''
      field.min = ''
      field.max = ''
      field.min = ''
      field.max = ''
      this.filter.changed = true
      this.onSetFilter()
    },
    async onFilterDialog () {
      console.log('onFilterDialog')
      const points_for_filter = await this.justpayPointService.getPointsForPaymentFilter2()
      this.filter_fields.common.data.map(item => {
        if (item.data === 'point_id') {
          item.select = [...points_for_filter]
          console.log('item.select', item.select)
          return item
        }
      })
      const clients = await this.justpayClient.getClients()
      this.filter_fields.common.data[3].select = [...clients]
      this.filter_dialog = true
    },
    onReport () {
      console.log('onReport')
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        delete request.data.set
        delete request.data.changed
      }
      request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
      // in PaymentController l.713 , field is "created"
      console.log('request.headers', request.headers)
      request.headers = request.headers.map(header => {
        if (header === 'createdTZ') {
          header = 'created'
        }
        // if (header === 'updatedTZ') {
        //   header = 'updated'
        // }
        return header
      })
      const form = $('<form>', {
        target: '_blank',
        action: '/api/finalrecon/export?token=' + localStorage.getItem("token"),
        method: 'post',
      })
      form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(request),
            name: 'form',
          })
      )
      form.appendTo('body').submit()
    },
    onSetFilter: function (flag) {
      if (this.filter.changed) this.filter.set = true
      this.filter.changed = false
      this.load()
      localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
    },
    onSetHeaders () {
      for (const x in this.headers) {
        this.headers[x].active = this.headers[x].active_temp
      }
      this.$axios.post('/api/user/headers', {
        entity: 'finalRecon',
        headers: this.headers.filter(a => a.active).map(a => a.value)
      })
          .catch(e => {
            console.log(e)
          })
    },
    onShowHeaderDialog () {
      console.log('onShowHeaderDialog')
      for (const x in this.headers) {
        this.headers[x].active_temp = this.headers[x].active
      }
      this.dialog.headers.show = true
    },
    onViewConfiguration (item) {
      const routeData = this.$router.resolve({ path: 'view', query: { id: item.id } })
      window.open(routeData.href, '_blank')
    },
    setDefaultHeaders () {
      if (!this.$store.state.user.finalRecon_headers || this.$store.state.user.finalRecon_headers.length == 0) return
      for (const x in this.headers) {
        this.headers[x].active = this.$store.state.user.finalRecon_headers.indexOf(this.headers[x].value) > -1
      }
    },
  }

}

</script>
<style scoped>

</style>
